import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagifyModule } from 'ngx-tagify';
import { GeneralSettingsComponent } from './general-settings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TagifyModule,
    GeneralSettingsComponent,
  ],
  exports: [GeneralSettingsComponent],
})
export class GeneralSettingsModule {}
